import { connect } from 'react-redux'
import { jsonApiWrapper, selectors } from '@opallabs/wormhole'
import { Avatar } from '.'

const getAvatarUuid = (proxiedUser) =>
  proxiedUser && proxiedUser.avatar && proxiedUser.avatar.uuid

const mapStateToProps = (state, props) => {
  const user = selectors.selectUserWithAvatar(state, props.userId)
  if (!user) return {}

  const proxiedUser = jsonApiWrapper({ data: user, state })

  return {
    avatarUuid: getAvatarUuid(proxiedUser),
    name: proxiedUser.fullName,
  }
}

export const ConnectedAvatar = connect(mapStateToProps)(Avatar)
